import { QRCodeSVG } from 'qrcode.react';
import { Box, Typography } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import { SecondaryButton } from './buttons';

const QRCode = ({ value, size = 200, title }) => {
    const handleDownload = () => {
        const svg = document.getElementById('qr-code-svg');
        if (!svg) return;

        const svgData = new XMLSerializer().serializeToString(svg);
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        const img = new Image();

        img.onload = () => {
            canvas.width = size;
            canvas.height = size;
            ctx.fillStyle = 'white';
            ctx.fillRect(0, 0, size, size);
            ctx.drawImage(img, 0, 0);

            const link = document.createElement('a');
            link.download = `qr-code-${title || 'camp'}.png`;
            link.href = canvas.toDataURL('image/png');
            link.click();
        };

        img.src = 'data:image/svg+xml;base64,' + btoa(unescape(encodeURIComponent(svgData)));
    };

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
            {title && (
                <Typography variant="subtitle2" color="text.secondary">
                    {title}
                </Typography>
            )}
            <Box
                sx={{
                    p: 2,
                    bgcolor: 'white',
                    borderRadius: 2,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}
            >
                <QRCodeSVG
                    id="qr-code-svg"
                    value={value}
                    size={size}
                    level="M"
                    includeMargin={false}
                />
            </Box>
            <SecondaryButton
                size="small"
                startIcon={<DownloadIcon />}
                onClick={handleDownload}
                fullWidth={false}
            >
                Скачать QR
            </SecondaryButton>
        </Box>
    );
};

export default QRCode;
